import React from "react"
import { UnorderedList } from "@carrotfertility/carotene-core"
import type { TwoColumnBulletListNode } from "../renderer/types"
import { ContentList } from "./content-item"

export function TwoColumnBulletListContent({ content }: { content: TwoColumnBulletListNode }) {
  return (
    <UnorderedList
      component="ul"
      sx={(theme) => ({
        display: "flex",
        gap: theme.spacing(theme.tokens.spacing.xs),
        paddingBlockStart: 0,
        paddingBlockEnd: (theme) => theme.spacing(theme.tokens.spacing.xl),
        flexWrap: "wrap",
        li: {
          "&:nth-child(odd)": {
            paddingInlineEnd: (theme) => theme.spacing(theme.tokens.spacing.sm)
          },
          inlineSize: { xs: "100%", md: `calc(50% - ${theme.spacing(theme.tokens.spacing.md)})` }
        }
      })}
    >
      <ContentList contents={content.content} asList />
    </UnorderedList>
  )
}
